import { useEffect, useRef } from 'react';
import { usePageContent } from '@/context/ContentContext';

export default function AboutSection() {
  const c = usePageContent('home');
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} className="relative w-full py-16 md:py-24 overflow-hidden bg-[#1a1a1a]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20workshop%20background%20with%20golden%20house%20number%20plates%20scattered%20on%20wooden%20workbench%2C%20warm%20amber%20lighting%2C%20tools%20and%20acrylic%20materials%2C%20artisan%20craftsman%20atmosphere%2C%20dramatic%20shadows%2C%20professional%20product%20photography%20background%20with%20shallow%20depth%20of%20field&width=1600&height=900&seq=about-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1a1a1a]/85" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-white mb-4">
            {c.about_heading}
          </h2>
          <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-white/70 leading-relaxed">
            {c.about_text}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { value: c.stat1_val, label: c.stat1_label },
            { value: c.stat2_val, label: c.stat2_label },
            { value: c.stat3_val, label: c.stat3_label },
            { value: c.stat4_val, label: c.stat4_label },
          ].map((stat, index) => (
            <div
              key={stat.label}
              className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out text-center p-6 bg-white/5 backdrop-blur-sm rounded-lg border border-white/10"
              style={{ transitionDelay: `${(index + 3) * 100}ms` }}
            >
              <div className="font-heading text-3xl md:text-4xl font-bold text-amber-400 mb-2">
                {stat.value}
              </div>
              <div className="text-sm font-label text-white/60">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}